const ECLIPSE_REEL_SELECTOR = '[data-ec-reel]';

let eclipseRetryArmed = false;

/** Un solo gesto del visitante basta para desbloquear la reproducción en iOS. */
function armRetryOnInteraction() {
  if (eclipseRetryArmed) return;
  eclipseRetryArmed = true;

  const retry = () => {
    document.querySelectorAll(`${ECLIPSE_REEL_SELECTOR}[data-ec-autoplay]`).forEach((video) => {
      if (video.dataset.ecInView !== 'false') playWhenReady(video);
    });
  };

  ['touchstart', 'pointerdown', 'click'].forEach((type) => {
    document.addEventListener(type, retry, { once: true, passive: true });
  });
}

function playWhenReady(video) {
  if (video.dataset.ecPlayPending === 'true' || !video.paused) return;
  video.dataset.ecPlayPending = 'true';

  const container = video.closest('[data-ec-reel-container]');

  const start = () => {
    delete video.dataset.ecPlayPending;
    video.defaultMuted = true;
    video.muted = true;
    video
      .play()
      .then(() => {
        if (container) delete container.dataset.ecReelFailed;
      })
      .catch(() => {
        // iOS puede rechazar el autoplay aunque el video esté silenciado.
        // Marcamos el contenedor para mostrar la portada en vez del control nativo.
        if (container) container.dataset.ecReelFailed = 'true';
        armRetryOnInteraction(video);
      });
  };

  if (video.readyState < HTMLMediaElement.HAVE_CURRENT_DATA) {
    video.addEventListener('loadeddata', start, { once: true });
    video.load();
    return;
  }

  start();
}

/**
 * La portada se pide recién al acercarse a la pantalla. Con el atributo `poster`
 * escrito desde Liquid, el navegador la descarga siempre, aunque el video esté a
 * tres pantallas de distancia. Va aparte del autoplay para que también funcione
 * con "reducir movimiento" o ahorro de datos, donde el reel no se reproduce.
 */
function armPoster(video) {
  if (!video.dataset.poster) return;

  const apply = () => {
    if (!video.dataset.poster) return;
    video.poster = video.dataset.poster;
    delete video.dataset.poster;
  };

  if (!('IntersectionObserver' in window)) {
    apply();
    return;
  }

  const watcher = new IntersectionObserver((entries) => {
    if (!entries.some((e) => e.isIntersecting)) return;
    apply();
    watcher.disconnect();
  }, { rootMargin: '300px 0px' });

  watcher.observe(video);
}

function setupEclipseReel(video) {
  if (video.dataset.ecReelReady === 'true') return;
  video.dataset.ecReelReady = 'true';

  armPoster(video);

  const container = video.closest('[data-ec-reel-container]');
  const isMobileHero = container?.dataset.ecReelMode === 'mobile-hero';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const saveData = navigator.connection?.saveData === true;

  video.defaultMuted = true;
  video.muted = true;

  video.addEventListener('ended', () => {
    if (!video.loop) return;
    video.currentTime = 0;
    playWhenReady(video);
  });
  if (!video.hasAttribute('data-ec-autoplay')) return;
  if (isMobileHero && !window.matchMedia('(max-width: 749px)').matches) return;
  if (!isMobileHero && (reducedMotion || saveData)) return;

  if (isMobileHero && !document.hidden) playWhenReady(video);

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const inView = entry.isIntersecting && entry.intersectionRatio >= 0.2;

      video.dataset.ecInView = inView ? 'true' : 'false';
      if (inView && !document.hidden) playWhenReady(video);
      else if (!inView && !video.paused) video.pause();
    });
  }, { threshold: [0, 0.2, 0.7] });

  observer.observe(video);
}

function setupEclipseReels(root = document) {
  root.querySelectorAll(ECLIPSE_REEL_SELECTOR).forEach(setupEclipseReel);
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setupEclipseReels());
else setupEclipseReels();

document.addEventListener('shopify:section:load', (event) => setupEclipseReels(event.target));
document.addEventListener('visibilitychange', () => {
  document.querySelectorAll(ECLIPSE_REEL_SELECTOR).forEach((video) => {
    if (document.hidden) video.pause();
    else if (video.dataset.ecInView === 'true') playWhenReady(video);
  });
});
window.addEventListener('pageshow', () => {
  document.querySelectorAll(`${ECLIPSE_REEL_SELECTOR}[data-ec-autoplay]`).forEach((video) => {
    if (video.dataset.ecInView !== 'false') playWhenReady(video);
  });
});
